import { useQuery } from "@tanstack/react-query"
import { getAdminReport } from "./AdminRepo"

// export const useAdminReport=({param={},enable}:{param:any,enable:boolean})=>{
//     return useQuery({
//         queryKey:['ADMIN_REPORT',param],
//         queryFn:()=>getAdminReport(param),
//         enabled:enable,
//         retry:false,
//     })
// }

export const useAdminReport = ({ param = {}, enable }: { param: any; enable: boolean }) => {
  return useQuery({
    queryKey: [
      'ADMIN_REPORT',
      param.action,
      param.page,
      param.limit,
      param.month,
      param.orgUnitId,
    ],
    queryFn: () => getAdminReport(param),
    enabled: enable,
    retry: false,
  });
};
